var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OssUpload',_vm._g(_vm._b({},'OssUpload',_vm.$_attrs,false),_vm.$listeners),[(!_vm.$_attrs.disabled)?_c('el-button',{attrs:{"size":"medium"}},[_c('i',{staticClass:"el-icon-upload2"}),_vm._v("点击上传 ")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afd212b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OssFileUpload/index.vue
// module id = null
// module chunks = 